import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
interface HeroSectionProps {
  onBookCall: () => void;
}
export function HeroSection({
  onBookCall
}: HeroSectionProps) {
  const firmLogos = ['Anderson & Partners', 'Mitchell Law Group', 'Sterling Legal', 'Blackwood Associates', 'Crawford & Cole', 'Hartley Law Firm'];
  return <section className="relative min-h-screen bg-navy overflow-hidden" data-id="element-55">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-56">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} data-id="element-57" />
      </div>

      {/* Gradient Overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-navy to-transparent" data-id="element-58" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20" data-id="element-59">
        {/* Callout */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-60">
          <span className="inline-block px-4 py-2 bg-gold/10 border border-gold/30 rounded-full text-gold text-sm font-medium tracking-wide" data-id="element-61">
            For Law Firm Owners Above $1M Who Want to Scale Profit, Not Payroll
          </span>
        </motion.div>

        {/* H1 Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-center font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-62">
          The AI Paralegal That Pays
          <br className="hidden md:block" data-id="element-63" /> for Itself in 60 Days.{' '}
          <span className="text-gold" data-id="element-64">Guaranteed.</span>
        </motion.h1>

        {/* Sub-headline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center text-lg md:text-xl text-white/80 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-65">
          Finally, a way to automate 80% of your firm's non billable work,
          recover thousands in lost billable hours, and eliminate the costs of
          hiring without lifting a finger.{' '}
          <span className="text-white font-medium" data-id="element-66">
            We build and manage your firm's entire AI operations for you.
          </span>
        </motion.p>

        {/* Animated Golden Arrows */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col items-center gap-0 mb-10" data-id="element-67">
          {[0, 1, 2].map(i => <motion.div key={i} animate={{
          y: [0, 12, 0],
          opacity: [0.4, 1, 0.4]
        }} transition={{
          duration: 1.4,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: i * 0.22
        }} data-id="element-68">
              <svg width="72" height="52" viewBox="0 0 72 52" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-69">
                <path d="M4 6L36 44L68 6" stroke="#FFBF00" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" data-id="element-70" />
              </svg>
            </motion.div>)}
        </motion.div>

        {/* Primary CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mb-4" data-id="element-71">
          <CTAButton onClick={onBookCall} size="large" data-id="element-72">
            Start Your Application
          </CTAButton>
        </motion.div>

        {/* Sub-text */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center text-muted text-sm mb-16" data-id="element-73">
          100% Free & No Obligation
        </motion.p>
      </div>
    </section>;
}